export default "__VITE_ASSET__cb751300__"